import * as React from 'react';
import {useSelector} from 'react-redux';
import {useAppDispatch} from '../../../../../redux';
import {change, getFormValues} from 'redux-form';
import View from './view';
import {Forms} from '../../../../../shared/models/forms';
import {ProductsPriceFilterForm, PropsProductPriceList} from '../../model';
import {leadingZeroesRegex} from '../../../../../shared/utils/text';

export const ProductPriceFilterList: React.FC<PropsProductPriceList> = (props) => {
  const filterProductsPriceFormValues = useSelector(
    getFormValues(Forms.productsPriceFilterForm),
  ) as ProductsPriceFilterForm;
  const dispatch = useAppDispatch();
  React.useEffect(() => {
    if (filterProductsPriceFormValues && filterProductsPriceFormValues.productPrice) {
      for (let index = 0; index < filterProductsPriceFormValues.productPrice.length; index++) {
        const element =
          filterProductsPriceFormValues.productPrice[index] &&
          filterProductsPriceFormValues.productPrice[index].toString();
        if (typeof element === 'string' && element.match(leadingZeroesRegex)) {
          dispatch(
            change(
              Forms.productsPriceFilterForm,
              `productPrice[${index}]`,
              Number(filterProductsPriceFormValues.productPrice[index].toString()),
            ),
          );
        }
      }
    }
  }, [filterProductsPriceFormValues]);

  const resetMin = () => {
    if (filterProductsPriceFormValues.productPrice) {
      dispatch(change(Forms.productsPriceFilterForm, 'productPrice[0]', undefined));
    }
  };

  const resetMax = () => {
    if (filterProductsPriceFormValues.productPrice) {
      dispatch(change(Forms.productsPriceFilterForm, 'productPrice[1]', undefined));
    }
  };

  return <View {...props} resetMax={resetMax} resetMin={resetMin} />;
};
